/**
 * One human sentence per storyboard gate failure, shared by every surface that
 * makes one — the dashboard's sign-off dialog and the board's stage menu — so
 * the same 409 reads the same everywhere.
 */
import { ApiError } from "../../core/api.js";

export function gateErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === "storyboard-not-in-review") {
      // Almost always a stale card: someone else moved the board while this
      // menu was open.
      return "The storyboard isn't in review right now.";
    }
    if (err.code === "board-archived") return "This board is archived.";
    if (err.status === 403) {
      return "Only a project manager can sign a storyboard off or send it back.";
    }
    if (err.status === 404) return "This board no longer exists.";
  }
  return err instanceof Error ? err.message : "That didn't work. Try again.";
}
